import * as Scrivito from "scrivito";
import EVENT_CATEGORIES from "^/Objs/EventPage/_eventCategories";

const categoryValues = [...EVENT_CATEGORIES.map((category) => category.key)];

const EventsSliderWidget = Scrivito.provideWidgetClass("EventsSliderWidget", {
  attributes: {
    eventCount: "integer",
    slideInterval: "integer",
    category: ["enum", { values: categoryValues }],
    eventLink: "link",
  },
});

export default EventsSliderWidget;
